/* eslint-disable import/prefer-default-export */
import { AreaSeries, AreaStack, BarGroup, BarSeries, BarStack, LineSeries } from '@visx/xychart';
export const SERIES_TYPES = {
  line: {
    Component: LineSeries
  },
  area: {
    Component: AreaSeries
  },
  bar: {
    Component: BarSeries
  },
  areaStack: {
    Component: AreaSeries,
    Container: AreaStack
  },
  barStack: {
    Component: BarSeries,
    Container: BarStack
  },
  barGroup: {
    Component: BarSeries,
    Container: BarGroup
  }
};
export const DEFAULT_RANGES = [{
  type: 'valueRange',
  name: '1-20',
  min: 1,
  max: 20
}, {
  type: 'valueRange',
  name: '21-50',
  min: 21,
  max: 50
}, {
  type: 'valueRange',
  name: '51-100',
  min: 51,
  max: 100
}, {
  type: 'valueRange',
  name: '101-200',
  min: 101,
  max: 200
}, {
  type: 'valueRange',
  name: '201-500',
  min: 201,
  max: 500
}];